import { Dialog } from "primereact/dialog"
import { useState, useEffect } from "react"
import styles from "../../../styles/Participant-GPRA.module.css"
import FormLabel from "../Common/FormLabel"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { SECTIONS } from "../types/interviewTypes"
import { InputSwitch } from "primereact/inputswitch"
import FormError from "../Common/FormError"
import { Button } from "primereact/button"
import { errorMessages } from "../types/messages"
import { existsErrors } from "../utils/utils"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"

const AddGroup = ({
  show,
  setShow,
  interviewType,
  section,
  organizations,
  selectedOrganizations,
  number,
  matrices,
  groupEditing,
  questions,
  updateGroup,
}) => {
  const userCtx = useContext(UserContext)
  const [groupModified, setGroupModified] = useState({
    id: 0,
    title: "",
    matrixId: undefined,
    alignment: undefined,
    editing: false,
    enabled: true,
    expanded: true,
    required: true,
  })
  const [validationErrors, setValidationErrors] = useState({})
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (groupEditing) {
      setGroupModified(groupEditing)
    }
  }, [groupEditing])

  const clearValues = () => {
    setGroupModified({
      title: "",
      enabled: true,
      required: true,
      id: 0,
      oldTitle: "",
      matrixId: undefined,
    })
    setValidationErrors({})
  }
  const validationForm = () => {
    let errors = {}
    if (!groupModified.title) {
      errors.title = errorMessages.requiredMessage
    }
    if (groupModified.id === 0 || !groupModified.id) {
      if (groupModified.title !== groupModified.oldTitle) {
        if (
          questions?.groups
            .filter((q) => q.section === section && q.form === interviewType)
            .some((q) => q.title === groupModified.title && !q.deleted)
        ) {
          errors.title = "This title it's already in use"
        }
      }
    } else {
      if (
        groupModified.title !== groupModified.additionalOldTitle &&
        questions?.groups.find((q) => q.id === groupModified.id)?.title !==
          groupModified.title &&
        questions?.groups
          .filter((q) => q.section === section && q.form === interviewType)
          .some((q) => q.title === groupModified.title && !q.deleted)
      ) {
        errors.title = "This title it's already in use"
      }
    }
    if (groupModified.alignment === undefined) {
      errors.alignment = errorMessages.requiredMessage
    }

    setValidationErrors(errors)
    return existsErrors(errors)
  }
  const renderFooter = () => {
    return (
      <>
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={() => {
              setShow(false)
              clearValues()
            }}
            className="p-button-text"
          />
          <Button
            label="Save"
            icon={
              saving && Object.entries(validationErrors)?.length === 0
                ? "pi pi-spin pi-spinner"
                : "pi pi-save"
            }
            onClick={() => {
              saveGroup()
            }}
            autoFocus
          />
        </div>
      </>
    )
  }
  const removeError = (key) => {
    validationErrors[key] = null
    setValidationErrors(validationErrors)
  }
  const getNumber = () => {
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_2) {
      return number + 1
    }
    if (section === INTERVIEW_SECTIONS.SUBSTANCE_USE_3) {
      return number + 5
    }
    if (section === INTERVIEW_SECTIONS.SERVICES_RECEIVED_5) {
      return number + 1
    }
    return number
  }
  const getGroupOrder = (matrixId) => {
    let groupOrder = 1
    const matrixGroups = matrices.find(
      (m) => m.title === matrixId
    )?.questionGroups
    if (matrixGroups?.length > 0) {
      groupOrder = groupOrder += matrixGroups.length
    }
    return groupOrder
  }
  const saveGroup = () => {
    setSaving(true)
    if (validationForm()) {
      let newSave = []
      if (groupModified.editing) {
        newSave = questions?.groups?.map((q) => {
          let newValue = { ...q }
          if (
            (newValue.title === groupModified.title ||
              newValue.title === groupModified.oldTitle) &&
            q.section === section &&
            q.form === interviewType
          ) {
            newValue.enabled = groupModified.enabled
            newValue.expanded = groupModified.expanded
            newValue.oldTitle = groupModified.oldTitle
            newValue.required = groupModified.required
            newValue.title = groupModified.title
            newValue.matrixId = groupModified.matrixId
            newValue.alignment = groupModified.alignment
            newValue.groupOrder = groupModified.groupOrder
            newValue.number = groupModified.number
            newValue.matrixGroup = questions.matrices?.find(
              (g) => g.title === groupModified.matrixId
            )
            newValue.additionalQuestions = groupModified.additionalQuestions
          }
          return newValue
        })
      } else {
        const newGroup = {
          id: groupModified.id,
          organizationUuid: userCtx.session.user.organization_id,
          form: interviewType,
          section: section,
          title: groupModified.title,
          oldTitle: groupModified.oldTitle,
          enabled: groupModified.enabled,
          expanded: groupModified.expanded,
          required: groupModified.required,
          number: getNumber(),
          organizations: organizations,
          selectedOrganizations: selectedOrganizations,
          matrixId: groupModified.matrixId,
          alignment: groupModified.alignment,
          groupOrder: getGroupOrder(groupModified.matrixId),
        }
        newSave = [...questions?.groups, newGroup]
      }
      clearValues()
      updateGroup(newSave)
      setSaving(false)
      setShow(false)
    }
  }
  const getMatrices = () => {
    return matrices?.map((matrix) => {
      return { label: matrix.title, value: matrix.title }
    })
  }
  const getAlignment = () => {
    return [
      { label: "Horizontal", value: 0 },
      { label: "Vertical", value: 1 },
    ]
  }
  return (
    <Dialog
      header={`${groupModified.editing ? "Edit" : "Add"} group`}
      visible={show}
      onHide={() => setShow(false)}
      breakpoints={{ "960px": "40vw" }}
      style={{ width: "35vw" }}
      footer={renderFooter()}
      closable={false}
      blockScroll={true}
    >
      <div className={styles.modalGrid}>
        <div className={styles.formRow}>
          <FormLabel label={"Form"} />
          <InputText
            value={interviewType}
            disabled
            className={styles.inputText7}
          />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Section"} />
          <Dropdown
            value={section}
            optionLabel="label"
            optionValue="value"
            disabled
            options={SECTIONS}
            className={styles.input7}
          />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Matrix"} />
          <Dropdown
            value={groupModified?.matrixId}
            optionLabel="label"
            optionValue="value"
            options={getMatrices()}
            showClear
            className={
              validationErrors?.matrix
                ? styles.inputText7Error
                : styles.inputText7
            }
            onChange={(e) => {
              setGroupModified({
                ...groupModified,
                matrixId: e.value,
                number: !e.value ? number : groupModified.number,
              })
              removeError("matrix")
            }}
          />
          <FormError error={validationErrors?.matrix} errorType={2} />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Alignment"} />
          <Dropdown
            value={groupModified?.alignment}
            optionLabel="label"
            optionValue="value"
            options={getAlignment()}
            showClear
            className={
              validationErrors?.alignment
                ? styles.inputText7Error
                : styles.inputText7
            }
            onChange={(e) => {
              setGroupModified({
                ...groupModified,
                alignment: e.value,
              })
              removeError("alignment")
            }}
          />
          <FormError error={validationErrors?.alignment} errorType={2} />
        </div>
        <div className={styles.formRow}>
          <FormLabel label={"Title"} />
          <InputText
            value={groupModified?.title}
            onChange={(e) => {
              setGroupModified({
                ...groupModified,
                title: e.target.value,
              })
              removeError("title")
            }}
            className={
              validationErrors?.title
                ? styles.inputText7Error
                : styles.inputText7
            }
          />
          <FormError error={validationErrors?.title} errorType={2} />
        </div>
        <div className={styles.formRow}>
          <div style={{ marginTop: "20px" }}>
            <label className={styles.ml1} htmlFor="binary">
              Enabled
            </label>
            <InputSwitch
              tooltip={
                groupModified.matrixGroup &&
                !groupModified?.matrixGroup?.enabled &&
                "Disabled matrix. Enable matrix first"
              }
              tooltipOptions={{ showOnDisabled: true }}
              disabled={
                groupModified?.matrixGroup &&
                !groupModified?.matrixGroup?.enabled
              }
              style={{ verticalAlign: "text-top", marginLeft: "7rem" }}
              checked={groupModified?.enabled}
              onChange={(e) => {
                setGroupModified({
                  ...groupModified,
                  enabled: e.value,
                })
              }}
            />
          </div>
        </div>
        <div className={styles.formRow}>
          <div style={{ marginTop: "20px" }}>
            <label className={styles.ml1} htmlFor="binary">
              Expanded
            </label>
            <InputSwitch
              style={{ verticalAlign: "text-top", marginLeft: "6.25rem" }}
              checked={groupModified?.expanded}
              onChange={(e) => {
                setGroupModified({
                  ...groupModified,
                  expanded: e.value,
                })
              }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}
export default AddGroup
